module.exports = __webpack_public_path__ + "public/SiteIcons/stripe-connect.png?0648ff63";